import { createReducer, on } from "@ngrx/store";

export const hospiFeatureKey = "hospi";

export interface HospitalizationState {

}

export const initialState: HospitalizationState = {

};

export const hospitalizationReducer = createReducer(
	initialState,

);
 